import { render, staticRenderFns } from "./messageReceiverList.vue?vue&type=template&id=e7ba3a44&scoped=true&"
import script from "./messageReceiverList.vue?vue&type=script&lang=js&"
export * from "./messageReceiverList.vue?vue&type=script&lang=js&"
import style0 from "./messageReceiverList.vue?vue&type=style&index=0&id=e7ba3a44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7ba3a44",
  null
  
)

export default component.exports